<template>
  <vs-popup class="create-courier-shipment-popup"
            id="popup"
            fullscreen
            title="CREATE ORDER ITEM SHIPMENT"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">

    <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="formSubmitted">
      <tab-content title="Select Order Items" class="mb-5" :before-change="validateStep1">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="customer_id" name="customer_id" rules="required" v-slot="{ errors }">
              <small class="label">Select Customer</small>
              <v-select v-on:input="fetchCustomerDeliveryAddresses()" @search="onSearch" :clearable="true" name="customer_id" placeholder=""
                        label="company_name" v-model="company"
                        :options="customers" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template slot="no-options">
                  type to search customer
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="formulation_items" name="formulation_items" rules="required" v-slot="{ errors }">
              <small class="label">Select a delivery address</small>
              <v-select
                style="z-index: 999;"
                v-on:input="getProductOrderList()"
                name="formulation_items" placeholder=""
                v-model="selectedAddress" :reduce="option => option"
                label="country"
                :options="customer_addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                    <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                    <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                    <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                    <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                    <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                    <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                    <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                    <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                    <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                    <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                  </div>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <label class="text-sm opacity-100 text-bold">Incoterms</label>
            <v-select  v-on:input="getProductOrderList()"  :clearable="true" placeholder=""  v-model="incoterm"
                       :options="incoterms" label="code" :reduce="option => option.code"
                       :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
          </div>
        </div>

        <vs-table :noDataText="company.id ? 'There are no goods in dispatch (pending) for this selected customer or address' : 'No data available. Please select a customer'" id="product-orders-table" v-can="'view-order'"
                  :max-items="(meta.per_page) ? meta.per_page : 15" :data="orders" @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container mt-8">

          <template slot="thead">
            <vs-th>DATE/TIME</vs-th>
            <vs-th width="10%" >CUSTOMER ACCOUNT NUMBER</vs-th>
            <vs-th sort-key="company_name" width="15%">CUSTOMER COMPANY</vs-th>
            <vs-th width="10%">ORDER CODE</vs-th>
            <vs-th>FINISHED PRODUCTS</vs-th>
            <vs-th>INCOTERMS</vs-th>
            <vs-th width="5%">QTY SCHEDULED FOR DISPATCH (KG)</vs-th>
            <vs-th></vs-th>
<!--            <vs-th width="10%" class="" v-can="'create-edit-order'">ACTION</vs-th>-->
          </template>

          <template slot-scope="{data}">
            <vs-tr  style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


              <vs-td :data="data[indextr].created_at">
                {{__dateTimeFormatter(data[indextr].created_at)}}
              </vs-td>

              <vs-td :data="data[indextr].customer.account_number">
                {{ data[indextr].customer.account_number}}
              </vs-td>

              <vs-td class="font-semibold text-primary" :data="data[indextr].customer.company_name">
                {{ data[indextr].customer.company_name}}
              </vs-td>


              <vs-td class="font-semibold" :data="data[indextr].product_order_code">
                {{ data[indextr].product_order_code}}
              </vs-td>

              <vs-td :data="data[indextr].formulations">
                    <span v-if="data[indextr].formulation_items.length > 0" v-for="item in data[indextr].formulation_items" :key="item.id">
                      <a class="text-sm" v-if="item.work_orders.length > 0">{{ item.formulation_code}} ({{ item.formulation_name }}), </a>
                    </span>
              </vs-td>

              <vs-td :data="data[indextr].formulations">
                    <span v-if="data[indextr].formulation_items.length > 0" v-for="item in data[indextr].formulation_items" :key="item.id">
                      <a class="text-sm" v-if="item.work_orders.length > 0">{{ item.incoterm }}, </a>
                    </span>
              </vs-td>

              <vs-td>
                {{ totalQtyAvailable(data[indextr].formulation_items) }}
              </vs-td>

              <vs-td>
<!--                <vx-tooltip-->
<!--                  v-if="!checkItemExists(data[indextr].formulation_items[0].id)-->
<!--                  && Number(data[indextr].formulation_items[0].quantity) > 0-->
<!--                  && data[indextr].formulation_items.length === 1"-->
<!--                  text="Select" position="top">-->
<!--                  <vs-button @click.stop="onClickAddItem(data[indextr].formulation_items[0], tr)"-->
<!--                             size="small" color="success" type="border" icon-pack="feather"-->
<!--                             icon="icon-plus">Add-->
<!--                  </vs-button>-->
<!--                </vx-tooltip>-->
                <vx-tooltip
                  v-if="!checkItemExists(data[indextr].formulation_items[0].id)
                  && Number(data[indextr].formulation_items[0].quantity) > 0
                  && data[indextr].formulation_items.length === 1"
                  text="Select" position="top">
                  <vs-button
                             size="small" color="success" type="border" icon-pack="feather"
                             icon="icon-plus">expand to view
                  </vs-button>
                </vx-tooltip>
                <vx-tooltip v-if="checkItemExists(data[indextr].formulation_items[0].id)  && data[indextr].formulation_items.length === 1" text="Remove" position="top">
                  <vs-button @click.stop="onClickRemoveItem(data[indextr].formulation_items[0].id, tr.id)"
                             size="small" color="danger" type="border" icon-pack="feather" icon="icon-x">
                    Remove
                  </vs-button>
                </vx-tooltip>
                <span class="text-warning" v-if="data[indextr].formulation_items.length > 1">
                  Multiple products. Click to view.
                </span>
              </vs-td>


<!--              <vs-td>-->

<!--                <div class="vx-row">-->
<!--                  <vx-tooltip v-if="!checkOrderExists(data[indextr].id)" text="Select" position="top">-->
<!--                    <vs-button @click.stop="onClickAddOrder(data[indextr])"-->
<!--                               size="small" color="success" type="border" icon-pack="feather" icon="icon-check"></vs-button>-->
<!--                  </vx-tooltip>-->
<!--                  <vx-tooltip v-if="checkOrderExists(data[indextr].id)" text="Remove" position="top">-->
<!--                    <vs-button @click.stop="onClickRemoveOrder(data[indextr].id)"-->
<!--                               size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>-->
<!--                  </vx-tooltip>-->
<!--                </div>-->

<!--              </vs-td>-->

              <template class="expand-user" slot="expand">
                <div class="con-expand-users w-full p-12">
                  <vs-table class="my-8" hoverFlat id="order_item_table" :data="data[indextr].formulation_items" stripe>

                    <template slot="thead">
                      <vs-th width="10%">ITS PRODUCT CODE</vs-th>
                      <vs-th width="5%">ORDER QUANTITY (KG)</vs-th>
                      <vs-th width="5%">MANUFACTURING PENDING QTY (KG)</vs-th>
                      <vs-th width="5%">DISPATCH PENDING QTY(KG)</vs-th>
                      <vs-th width="5%">UNIT PRICE (GBP/KG)</vs-th>
                      <vs-th width="5%" class="text-xs">REQUIRED BY DATE</vs-th>
                      <vs-th width="5%" class="text-xs">INCOTERM</vs-th>
                      <vs-th width="15%" class="text-xs">ORDER STATUS</vs-th>
                      <vs-th width="15%" class="text-xs">QC STATUS</vs-th>
                      <vs-th width="10%" class="text-xs">DELIVERY POSTAL CODE</vs-th>
                      <!-- <vs-th width="" class="text-xs">DISPATCHES ALREADY BOOKED</vs-th> -->
                      <vs-th width="">ACTION</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr v-if="data[index_item].work_orders.length > 0" :key="index_item" v-for="(tr_item, index_item) in data">

                        <vs-td :data="data[index_item].formulation_code">
                      <span>
                        <a>{{ data[index_item].formulation_code }}</a>
                      </span>
                        </vs-td>

                        <vs-td :data="data[index_item].quantity">
                          {{ data[index_item].quantity | four_decimals }}
                        </vs-td>

                        <vs-td :data="data[index_item].pending_dispatch_quantity">
                          {{ Number(data[index_item].pending_manufacture_quantity).toFixed(4) }}
                        </vs-td>

                        <vs-td>
                          {{ (data[index_item].pending_dispatch_quantity - data[index_item].pending_manufacture_quantity) | four_decimals}}
                        </vs-td>

                        <vs-td :data="data[index_item].price">
                          {{ (Number(data[index_item].price)).toFixed(2) }}
                        </vs-td>

                        <vs-td>
                          {{ manufacturingDateFactory(data[index_item].work_orders) }}
                        </vs-td>

                        <vs-td>
                          {{ data[index_item].incoterm || 'N/A' }}
                        </vs-td>

                        <vs-td :data="data[index_item].item_status">
                          <vs-chip class="text-center text-xs" transparent>
                            {{ orderItemStatusNameFactory(data[index_item].item_status, data[index_item].work_orders) }}
                          </vs-chip>
                        </vs-td>

                        <vs-td :data="data[index_item].item_status">
                          <vs-chip class="text-center text-xs" transparent>
                            {{ orderItemQcStatusNameFactory(data[index_item].work_orders) }}
                          </vs-chip>
                        </vs-td>

                        <vs-td>
                          {{ data[index_item].post_code }}
                        </vs-td>

                        <!-- <vs-td>
                          <span v-if="data[index_item].courier_shipments.length > 0"
                                v-for="courier in data[index_item].courier_shipments" :key="courier.id">
                            <a @click="onClickViewShipment(courier.id)" class="text-sm cursor-pointer">{{ courier.courier_shipment_code }}, </a>
                          </span>
                        </vs-td> -->


                        <vs-td>
<!--                          v-if="['In-Manufacturing', 'In-Dispatch'].includes(data[index_item].item_status ) && Number(data[index_item].pending_dispatch_quantity) > 0"-->
                          <div class="vx-row">
<!--                            <vx-tooltip v-if="!checkItemExists(data[index_item].id) && Number(data[index_item].quantity) > 0" text="Select" position="top">-->
<!--                              <vs-button @click.stop="onClickAddItem(data[index_item], tr)"-->
<!--                                         size="small" color="success" type="border" icon-pack="feather" icon="icon-plus">Add</vs-button>-->
<!--                            </vx-tooltip>-->
                            <vx-tooltip v-if="!checkItemExists(data[index_item].id) && Number(data[index_item].quantity) > 0" text="Select" position="top">
                              <vs-button
                                         size="small" color="success" type="border" icon-pack="feather" icon="icon-plus">expand to view</vs-button>
                            </vx-tooltip>
                            <vx-tooltip v-if="checkItemExists(data[index_item].id)" text="Remove" position="top">
                              <vs-button @click.stop="onClickRemoveItem(data[index_item].id, tr.id)"
                                         size="small" color="danger" type="border" icon-pack="feather" icon="icon-x">Remove</vs-button>
                            </vx-tooltip>
                          </div>
                        </vs-td>

                        <template class="expand-user" slot="expand">
                          <div class="con-expand-users w-5/5">
                            <vs-table noDataText="" class="my-8" hoverFlat id="order_item_work_order_table" stripe>

                              <template slot="header">
                                <h5 class="mb-4">Dispatch Bookings</h5>
                              </template>

                              <template slot="thead">
                                <vs-th width="10%">WO DATE</vs-th>
                                <vs-th width="10%">WO CODE</vs-th>
                                <vs-th width="10%">SO CODE(S)</vs-th>
                                <vs-th width="5%">MANUFACTURED QTY (KG)</vs-th>
                                <vs-th width="6%">DISPATCHED QTY (KG)</vs-th>
                                <vs-th width="6%">DISPATCH PENDING QTY (KG)</vs-th>
                                <vs-th width="6%" class="text-xs">WO STATUS</vs-th>
                                <vs-th width="6%" class="text-xs">WO QC STATUS</vs-th>
                                <vs-th width="6%" class="text-xs">STOCK STATUS</vs-th>
                                <vs-th width="15%" class="text-xs">SHIPMENTS</vs-th>
                                <vs-th width="20%">QTY TO SHIP (KG)</vs-th>
                                <vs-th width="10%">ACTION</vs-th>
                              </template>

                              <template slot-scope="{data}">
                                <vs-tr :key="index_wo" v-for="(tr_wo, index_wo) in tr_item.work_orders">

                                  <vs-td :data="tr_wo.work_order_date">
                                    {{ tr_wo.work_order_date }}
                                  </vs-td>

                                  <vs-td :data="tr_wo.work_order_code">
                                    {{ tr_wo.work_order_code }}
                                  </vs-td>

                                  <vs-td>
                                    <span v-if="tr_wo.sales_orders && tr_wo.sales_orders.length">
                                      <span v-for="(so, so_index) in tr_wo.sales_orders" :key="so.id">
                                        <HyperLink :id="so.id" type="product-order">{{ so.order_code }}</HyperLink><span v-if="so_index < tr_wo.sales_orders.length - 1">, </span>
                                      </span>
                                    </span>
                                    <span v-else>N/A</span>
                                  </vs-td>

                                  <vs-td :data="tr_wo.completed_quantity">
                                    {{ tr_wo.completed_quantity | four_decimals}}
                                  </vs-td>

                                  <vs-td>
                                    {{ tr_wo.shipped_quantity | four_decimals }}
                                  </vs-td>

                                  <vs-td>
                                    {{ tr_wo.shipping_max_quantity | four_decimals }}
                                  </vs-td>

                                  <vs-td :data="tr_wo.status">
                                    {{ tr_wo.status }}
                                  </vs-td>

                                  <vs-td :data="tr_wo.qc_status">
                                    {{ tr_wo.qc_status || 'Pre QC'}}
                                  </vs-td>

                                  <vs-td :data="tr_wo.stock_status">
                                    {{ tr_wo.stock_status | stock_status_format }}                                 
                                  </vs-td>

                                  <vs-td>
                                    {{ shipmentCodeFilter(tr_wo.courier_shipment) }}
                                  </vs-td>

                                  <vs-td>
                                    <ValidationProvider v-if="ifShipmentCanMake(tr_wo.courier_shipment, tr_wo.shipping_max_quantity)" :vid="index_wo+'shipping_quantity'" :name="index_wo+'shipping_quantity'" :rules="`required|min_qty:${tr_wo.shipping_max_quantity}`" v-slot="{ errors }">
                                      <input type="number" style="border: 1px solid #CCCCCC; outline: none; width: 30px" class="w-full h-10 rounded-lg m-2 p-2"
                                        v-model="tr_wo.shipping_quantity"/>
                                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                  </vs-td>

                                  <vs-td>
                                    <div class="vx-row" v-if="ifShipmentCanMake(tr_wo.courier_shipments, tr_wo.shipping_max_quantity) && Number(tr_wo.shipping_max_quantity) >= Number(tr_wo.shipping_quantity)">
                                      <vx-tooltip v-if="!checkItemWoSelected(tr_wo.id, tr_item.id, tr_wo.stock_id)" text="Select" position="top">
                                        <vs-button @click.stop="onClickAddItem(tr_item, tr, tr_wo)"
                                                   size="small" color="success" type="border" icon-pack="feather" icon="icon-plus">Add</vs-button>
                                      </vx-tooltip>
                                      <vx-tooltip v-if="checkItemWoSelected(tr_wo.id, tr_item.id, tr_wo.stock_id)" text="Select" position="top">
                                        <vs-button @click.stop="onClickRemoveItem(tr_item.id, tr.id, tr_wo.stock_id)"
                                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-x">Remove</vs-button>
                                      </vx-tooltip>
                                    </div>
                                  </vs-td>

                                </vs-tr>
                              </template>

                            </vs-table>
                          </div>
                        </template>

                      </vs-tr>
                    </template>

                  </vs-table>
                </div>
              </template>

            </vs-tr>
            <vs-tr v-if="orders.length > 0">
              <vs-td></vs-td>
              <vs-td colspan="6" style="font-weight: bolder">Total</vs-td>
              <vs-td style="font-weight: bolder">{{ totalCalculator() }}</vs-td>
              <vs-td></vs-td>
            </vs-tr>
          </template>


        </vs-table>


        <vs-pagination
          v-if="orders.length > 0"
          v-on:changeMaxItems="changePage"
          :size-array="meta.total ? meta.total : 20"
          :max-items="perPage"
          description-body="Rows per page"
          description-connector="of"
          description-title="Records"
          description
          :description-items="descriptionItems"
          :total="(meta.last_page)? meta.last_page : 0"
          v-model="page"  class="p-5">
        </vs-pagination>

      </tab-content>
      <tab-content title="Shipment Details" class="mb-5" :before-change="validateStep2">

        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <vs-table stripe class="mb-8" :data="selected_items">

            <template slot="thead">
              <vs-th width="25%">ITS PRODUCT CODE</vs-th>
              <vs-th width="20%">INCOTERM</vs-th>
              <vs-th width="20%">ORDER QUANTITY (KG)</vs-th>
<!--              <vs-th width="20%">REMAINING QTY TO DISPATCH (KG)</vs-th>-->
              <vs-th width="20%">QTY TO SHIP (KG)</vs-th>
              <vs-th width="15%"></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].formulation_code">
                  {{ data[indextr].formulation_code  }}
                </vs-td>

                <vs-td :data="data[indextr].incoterm">
                  {{ data[indextr].incoterm || 'N/A' }}
                </vs-td>

                <vs-td :data="data[indextr].quantity">
                  {{ Number(data[indextr].quantity).toFixed(2) }}
                </vs-td>

<!--                <vs-td :data="data[indextr].pending_dispatch_quantity">-->
<!--                  {{ Number(data[indextr].pending_dispatch_quantity).toFixed(2) }}-->
<!--                </vs-td>-->

                <vs-td :data="data[indextr].quantity">
<!--                  <ValidationProvider :vid="indextr+'selected_qty'" :name="indextr+'selected_qty'" :rules="'maxoq:'+data[indextr].pending_dispatch_quantity" v-slot="{ errors }">-->
<!--                    <vs-input v-on:input="handleGrossWeight()" type="text" v-model="data[indextr].selected_qty" class="w-full"-->
<!--                              :name="indextr+'selected_qty'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"-->
<!--                              val-icon-pack="feather"/>-->
<!--                  </ValidationProvider>-->
                  <!-- {{ data[indextr].selected_qty }} -->
                  {{ calculateSelectedQty(data[indextr].work_orders) }}

                </vs-td>

                <vs-td>
                    <span class="text-primary text-sm">Expand to adjust dispatch quantity</span>
                </vs-td>

                <template class="expand-user" slot="expand">
                  <div class="con-expand-users w-4/5">
                    <vs-table noDataText="" class="my-8" hoverFlat id="order_item_work_order_table" stripe>

                      <template slot="header">
                        <h5 class="mb-4">Dispatch Bookings</h5>
                      </template>

                      <template slot="thead">
                        <vs-th width="10%">WO DATE</vs-th>
                          <vs-th width="10%">WO CODE</vs-th>
                          <vs-th width="15%">SO CODE(S)</vs-th>
                          <vs-th width="10%" class="text-xs">WO STATUS</vs-th>
                          <vs-th width="10%" class="text-xs">QC STATUS</vs-th>
                          <vs-th width="10%">COMPLETED QTY (KG)</vs-th>
                          <vs-th width="10%">DISPATCHED QTY (KG)</vs-th>
                          <vs-th width="15%">QTY TO SHIP (KG)</vs-th>
                          <vs-th width="10%">PACK SIZE (KG)</vs-th>
                        <!--                          <vs-th width="10%">ACTION</vs-th>-->
                      </template>

                      <template slot-scope="{data}">
                        <vs-tr :key="index_wo" v-for="(tr_wo, index_wo) in tr.work_orders">

                          <vs-td :data="tr_wo.work_order_date">
                            {{ tr_wo.work_order_date }}
                          </vs-td>

                          <vs-td :data="tr_wo.work_order_code">
                            <a @click.stop="onClickViewWorkOrder(tr_wo.id)">{{ tr_wo.work_order_code }}</a>
                          </vs-td>

                          <vs-td>
                            <span v-if="tr_wo.sales_orders && tr_wo.sales_orders.length">
                              <span v-for="(so, so_index) in tr_wo.sales_orders" :key="so.id">
                                <HyperLink :id="so.id" type="product-order">{{ so.order_code }}</HyperLink><span v-if="so_index < tr_wo.sales_orders.length - 1">, </span>
                              </span>
                            </span>
                            <span v-else>N/A</span>
                          </vs-td>

                          <vs-td :data="tr_wo.status">
                            {{ tr_wo.status }}
                          </vs-td>

                          <vs-td :data="tr_wo.qc_status">
                            {{ tr_wo.qc_status || 'Pre QC'}}
                          </vs-td>

                          <vs-td :data="tr_wo.completed_quantity">
                            {{ Number(tr_wo.completed_quantity).toFixed(2) }}
                          </vs-td>

                          <vs-td>
                              {{ tr_wo.shipped_quantity }}
                          </vs-td>

                          <vs-td>
                              <ValidationProvider :vid="index_wo+'shipping_quantity'" :name="index_wo+'shipping_quantity'" :rules="`required|min_qty:${tr_wo.shipping_max_quantity}`" v-slot="{ errors }">
                                <input type="number" style="border: 1px solid #CCCCCC; outline: none; width: 30px" class="w-full h-10 rounded-lg m-2 p-2"
                                      v-model="tr_wo.shipping_quantity"/>
                                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                              </ValidationProvider>
                          </vs-td>

                          <vs-td :data="tr_wo.pack_size">
<!--                            <vs-input type="number" v-model="tr_wo.pack_size"-->
<!--                                      class="w-full"-->
<!--                                      :name="index_wo+'pack_size'"-->
<!--                                      val-icon-danger="icon-x"-->
<!--                                      val-icon-pack="feather"/>-->
                            <input type="number" style="border: 1px solid #CCCCCC; outline: none;"
                                   class="w-full h-10 rounded-lg m-2 p-2" v-model="tr_wo.pack_size"/>

                          </vs-td>


                        </vs-tr>
                      </template>

                    </vs-table>
                  </div>
                </template>
              </vs-tr>
            </template>
          </vs-table>

          <div class="vx-row">
            <div class="vx-col md:w-2/5 w-full md:mb-0">

              <div class="vx-row mb-3" v-if="selected_items.length > 0 && selected_items[0].incoterm !== 'EXW'">
                <div class="vx-col w-full">
                  <vx-card-custom title="DHL Shipment" cardBorder no-shadow :collapse-action="false">
                    <small class="label">Enable</small>
                    <vs-switch @input="onInputDhlConfig" color="primary" v-model="dhl_shipment" icon-pack="feather" class="w-16">
                    </vs-switch>
                    <DhlShipmentForm class="mt-6" v-if="dhl_shipment" @update-form="dhlForm = $event" :shipment_form="createForm" :invoices="availableInvoices" />
                  </vx-card-custom>
                </div>
              </div>

              <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false">
                <div v-if="selected_items.length > 0 && selected_items[0].incoterm !== 'EXW' && !dhl_shipment" class="vx-row mb-3">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                      <small class="label">Type</small>
                      <v-select v-on:input="onChangeCourierType()" :clearable="false" v-model="createForm.type"
                                :options="types" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3" v-if="!supplier_id && !dhl_shipment">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="supplier_id" name="supplier_id" rules="" v-slot="{ errors }">
                      <small class="label">Courier Supplier</small>
                      <v-select :clearable="false" label="company_name" v-model="createForm.supplier_id"
                                :reduce="option => option.id" :options="courier_suppliers" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div :class="createForm.transport_mode === 'air' ? 'vx-col md:w-1/2 w-full md:mb-0' : 'vx-col md:w-full w-full md:mb-0'">
                    <ValidationProvider vid="transport_mode" name="transport_mode" rules="" v-slot="{ errors }">
                      <small class="label">Transport Mode</small>
                      <v-select :clearable="true" placeholder="Select Transport Mode" v-model="createForm.transport_mode"
                                :options="transport_modes" label="label" :reduce="option => option.value"
                                @input="onChangeTransportMode"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="createForm.transport_mode === 'air'">
                    <ValidationProvider vid="sub_transport_type" name="sub_transport_type" rules="" v-slot="{ errors }">
                      <small class="label">Sub Transport Type</small>
                      <v-select :clearable="true" placeholder="Select Sub Transport Type" v-model="createForm.sub_transport_type"
                                :options="sub_transport_types" label="label" :reduce="option => option.value"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

              </vx-card-custom>

              <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false" v-if="!dhl_shipment">
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/2">
                    <ValidationProvider vid="date_of_booking" name="date_of_booking" rules="required" v-slot="{ errors }">
                      <small class="label">Date of booking</small>
                      <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y'}"
                                  v-model="createForm.date_of_booking" placeholder="Choose Date"
                      />
                      <flat-pickr
                        class="w-full"
                        :config="{ dateFormat: 'd/m/Y'}"
                        v-model="createForm.date_of_booking"
                        placeholder="Choose Date"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-1/2">
                    <ValidationProvider vid="estimated_delivery_date" name="estimated_delivery_date" rules="required"
                                        v-slot="{ errors }">
                      <small class="label">
                        {{ (selected_items.length > 0 && selected_items[0].incoterm !== 'EXW') ? 'Estimated delivery & invoice date' : 'Collection date' }}
                      </small>
                      <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y', minDate: 'today'}"
                                  v-model="createForm.estimated_delivery_date" placeholder="Choose Date"
                      />
                      <flat-pickr
                        class="w-full"
                        :config="{ dateFormat: 'd/m/Y', minDate: 'today'}"
                        v-model="createForm.estimated_delivery_date"
                        placeholder="Choose Date"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </vx-card-custom>

              <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false" v-if="!dhl_shipment">
                <div class="vx-row mb-8">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="cost_of_delivery" name="cost_of_delivery" rules="required" v-slot="{ errors }">
                      <small class="label">Cost of delivery (Excl VAT/TAX) in GBP</small>
                      <vs-input v-model="createForm.cost_of_delivery" name="cost_of_delivery" class="w-full" label=""
                                :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="booking_reference_number" name="booking_reference_number" rules="required"
                                        v-slot="{ errors }">
                      <small class="label">Booking ref number</small>
                      <vs-input v-model="createForm.booking_reference_number" name="booking_reference_number" class="w-full"
                                label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>
              </vx-card-custom>

              <!-- <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false">
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="'net_weight'"
                                        :name="'net_weight'" rules="required"
                                        v-slot="{ errors }">
                      <small class="label">Net Weight (KG)</small>
                      <vs-input v-model="createForm.net_weight" name="net_weight" class="w-full" label=""
                                :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="'gross_weight'" :name="'gross_weight'"
                                        rules="required" v-slot="{ errors }">
                      <small class="label">Gross Weight (KG)</small>
                      <vs-input v-model="createForm.gross_weight" name="gross_weight" class="w-full" label=""
                                :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>
              </vx-card-custom> -->

              <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false">
              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="sage_department" name="sage_department" rules="required" v-slot="{errors}">
                    <small class="label">Sage Department</small>
                    <v-select :clearable="false" name="sage_department" placeholder=""
                              label="name" v-model="createForm.sage_department_id" :reduce="option => option.id"
                              :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="region" name="region" rules="required" v-slot="{errors}">
                    <small class="label">Region</small>
                    <v-select :clearable="false" name="region" placeholder=""
                              label="name" v-model="createForm.region_id" :reduce="option => option.id"
                              :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              </vx-card-custom>

              <vx-card-custom class="mb-4" :title="'Order Invoices'" :cardBorder="true" no-shadow :collapse-action="false">
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="product_order_invoice_id" name="product_order_invoice_id" rules="" v-slot="{errors}">
                      <small class="label">Invoices to send with shipment</small>
                      <v-select :clearable="true" placeholder="Select invoices"
                                v-model="createForm.product_order_invoice_id"
                                multiple :closeOnSelect="false"
                                :options="availableInvoices"
                                label="number"
                                :reduce="option => option.id"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                :disabled="availableInvoices.length === 0">
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                      <small v-if="availableInvoices.length === 0" class="text-muted text-xs">No invoices available for the selected order(s).</small>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row" v-if="availableInvoices.length > 1">
                  <vs-button v-if="createForm.product_order_invoice_id.length !== availableInvoices.length" @click.stop="onClickSelectAllInvoices" size="small" class="ml-4">Select all</vs-button>
                  <vs-button v-if="createForm.product_order_invoice_id.length > 0" @click.stop="onClickRemoveAllInvoices" color="danger" size="small" class="ml-4">Clear all</vs-button>
                </div>
              </vx-card-custom>

              <!--            <span class="mt-8 mb-4 font-semibold">Delivery Address</span>-->

              <vx-card-custom :title="'Delivery Address'" :cardBorder="true" no-shadow :collapse-action="false">
                <div class="vx-row mb-3 mt-0">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="address_line_1" name="address_line_1" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 1</small>
                      <vs-input readonly v-model="createForm.delivery_address.address_line_1"  name="address_line_1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="address_line_2" name="address_line_2" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 2</small>
                      <vs-input readonly v-model="createForm.delivery_address.address_line_2"  name="address_line_2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="address_line_3" name="address_line_3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input readonly v-model="createForm.delivery_address.address_line_3"  name="address_line_3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town State</small>
                      <vs-input readonly v-model="createForm.delivery_address.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="postcode" name="postcode" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input readonly v-model="createForm.delivery_address.postcode"  name="postcode" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <vs-input readonly v-model="createForm.delivery_address.country"  name="country" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full md:mb-0">
                      <ValidationProvider vid="postcode" name="postcode" rules="" v-slot="{ errors }">
                        <small class="label">Delivery Instructions</small>
                        <vs-textarea v-model="createForm.delivery_address.delivery_instruction"></vs-textarea>
                      </ValidationProvider>
                    </div>
                </div>
              </vx-card-custom>


              <div class="vx-row mb-3 mt-4">
                <div class="vx-col w-full">
                  <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                    <small class="label">Note</small>
                    <vs-textarea class="mb-0" v-model="createForm.note" height="100px" />
                    <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

            </div>
            <div class="vx-col md:w-3/5 w-full md:mb-0">

              <vx-card-custom :title="'Package Details'" :cardBorder="true" no-shadow :collapse-action="false">

                <div class="vx-row mb-3">
                  <div class="vx-col w-1/2">
                    <ValidationProvider vid="separate_item_count" name="separate_item_count" rules="required" v-slot="{ errors }">
                      <small class="label">How many separate items in this shipping booking?</small>
                      <vs-input type="number" v-on:input="onChangeSeparateItemCount()" v-model="separate_item_count" name="separate_item_count" class="w-full"
                                label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <vs-table stripe class="mb-8" :data="package_details">

                  <template slot="thead">
<!--                    <vs-th class="text-xs" width="15%">ORDER CODE</vs-th>-->
                    <vs-th class="text-xs" width="25%">ITEM DESCRIPTION</vs-th>
                    <vs-th class="text-xs" width="15%">GROSS WEIGHT (KG)</vs-th>
                    <vs-th class="text-xs" width="15%">NET WEIGHT (KG)</vs-th>
                    <vs-th class="text-xs" width="15%">LENGTH (cm)</vs-th>
                    <vs-th class="text-xs" width="15%">WIDTH (cm)</vs-th>
                    <vs-th class="text-xs" width="15%">HEIGHT (cm)</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

<!--                      <vs-td :data="data[indextr].order_code">-->
<!--                        <vs-dropdown >-->

<!--                          <a class="flex items-center">-->
<!--                            {{ data[indextr].order_code || 'SELECT'}}-->
<!--                            <i class="material-icons"> expand_more </i>-->
<!--                          </a>-->

<!--                          <vs-dropdown-menu style="z-index: 99999">-->

<!--                            <vs-dropdown-item @click="onClickOrderNumber(order, indextr)" v-for="(order, index_order) in selected_orders" :key="index_order">-->
<!--                              <span >{{ order.product_order_code }}</span>-->
<!--                            </vs-dropdown-item>-->

<!--                          </vs-dropdown-menu>-->
<!--                        </vs-dropdown>-->
<!--                      </vs-td>-->

                      <vs-td :data="data[indextr].item_number">
                        <ValidationProvider :vid="indextr+'pallet_number'" :name="indextr+'pallet_number'" rules="" v-slot="{ errors }">
                          <vs-input type="text" v-model="data[indextr].item_number" class="w-full"
                                    :name="indextr+'pallet_number'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather"/>
                        </ValidationProvider>

                      </vs-td>

                      <vs-td :data="data[indextr].gross_weight">
                        <ValidationProvider :vid="indextr+'gross_weight'" :name="indextr+'gross_weight'" rules="required" v-slot="{ errors }">
                          <vs-input type="text" v-model="data[indextr].gross_weight" class="w-full"
                                    :name="indextr+'gross_weight'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather"/>
                        </ValidationProvider>
                      </vs-td>

                      <vs-td :data="data[indextr].net_weight">
                        <ValidationProvider :vid="indextr+'net_weight'" :name="indextr+'net_weight'" :rules="`required|net_weight:@${indextr}gross_weight`" v-slot="{ errors }">
                          <vs-input type="text" v-model="data[indextr].net_weight" class="w-full"
                                    :name="indextr+'net_weight'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather"/>
                        </ValidationProvider>
                      </vs-td>

                      <vs-td :data="data[indextr].cubic_meter_lenght">
                        <ValidationProvider :vid="indextr+'cubic_meter_lenght'" :name="indextr+'cubic_meter_lenght'" rules="required" v-slot="{ errors }">
                          <vs-input type="text" v-model="data[indextr].cubic_meter_lenght" class="w-full"
                                    :name="indextr+'cubic_meter_lenght'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather"/>
                        </ValidationProvider>
                      </vs-td>

                      <vs-td :data="data[indextr].cubic_meter_width">
                        <ValidationProvider :vid="indextr+'cubic_meter_width'" :name="indextr+'cubic_meter_width'" rules="required" v-slot="{ errors }">
                          <vs-input type="text" v-model="data[indextr].cubic_meter_width" class="w-full"
                                    :name="indextr+'cubic_meter_width'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather"/>
                        </ValidationProvider>
                      </vs-td>

                      <vs-td :data="data[indextr].cubic_meter">
                        <ValidationProvider :vid="indextr+'cubic_meter_height'" :name="indextr+'cubic_meter_height'" rules="required" v-slot="{ errors }">
                          <vs-input type="text" v-model="data[indextr].cubic_meter_height" class="w-full"
                                    :name="indextr+'cubic_meter_height'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather"/>
                        </ValidationProvider>
                      </vs-td>


                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card-custom>

              <vx-card-custom class="my-4" :title="'Package Summary'" :cardBorder="true" no-shadow :collapse-action="false">
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider :vid="'net_weight'"
                                          :name="'net_weight'" rules="required"
                                          v-slot="{ errors }">
                        <small class="label">Net Weight (KG)</small>
                        <vs-input disabled v-model="createForm.net_weight" name="net_weight" class="w-full" label=""
                                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                  val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider :vid="'gross_weight'" :name="'gross_weight'"
                                          rules="required" v-slot="{ errors }">
                        <small class="label">Gross Weight (KG)</small>
                        <vs-input disabled v-model="createForm.gross_weight" name="gross_weight" class="w-full" label=""
                                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                  val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>
                </vx-card-custom>

              <div class="vx-row mb-3 mt-8" v-if="is_included_dgn_note_items">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                  Ship by limited quantity
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                  <vs-switch color="primary" v-on:input="onChangeDgnRequired()" v-model="createForm.is_hazardous" icon-pack="feather" class="w-16">
                    <span slot="on">DGN</span>
                    <span slot="off">SLQ</span>
                  </vs-switch>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                  DGN Required
                </vs-col>
              </div>

              <span v-if="is_included_dgn_note_items">
              <vs-row vs-w="12" class="mt-8">
                     <vs-col v-for="(dangerous, index_dangerous) in createForm.dangerous_goods_details_arr"
                             :key="index_dangerous"
                             vs-type="flex"
                             vs-justify="center"
                             vs-align="center"
                             vs-lg="12" vs-sm="12" vs-xs="12"
                             class="px-4 pb-4">
                       <vx-card-custom :title="dangerous.product_code" v-on:remove="onDeleteDangerousItem(dangerous.product_code)" :cardBorder="true" no-shadow :remove-card-action="false" :collapse-action="false">

                         <div class="vx-row mb-3">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'product_code'"
                                                :name="index_dangerous+'product_code'" rules="required"
                                                v-slot="{ errors }">
                              <small class="label">Product Code</small>
                              <vs-input v-model="dangerous.product_code" name="product_code" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'legal_name'" :name="index_dangerous+'legal_name'"
                                                rules="required" v-slot="{ errors }">
                              <small class="label">Legal Name</small>
                              <vs-input v-model="dangerous.legal_name" name="legal_name" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>
                         <div class="vx-row mb-3">
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                               <ValidationProvider :vid="index_dangerous+'un_number'"
                                                   :name="index_dangerous+'un_number'" :rules="createForm.is_hazardous ? 'required' : ''"
                                                   v-slot="{ errors }">
                                 <small class="label">UN Number</small>
                                 <vs-input v-model="dangerous.un_number" name="un_number" class="w-full" label=""
                                           :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                           val-icon-pack="feather"/>
                               </ValidationProvider>
                          </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                               <ValidationProvider :vid="index_dangerous+'hazard_class_number'"
                                                   :name="index_dangerous+'hazard_class_number'" :rules="createForm.is_hazardous ? 'required' : ''"
                                                   v-slot="{ errors }">
                                 <small class="label">Transport Hazard Class</small>
                                 <vs-input v-model="dangerous.hazard_class_number" name="hazard_class_number"
                                           class="w-full" label=""
                                           :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                           val-icon-pack="feather"/>
                               </ValidationProvider>
                          </div>
                         </div>
                         <div class="vx-row mb-3">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'tunnel_code'"
                                                :name="index_dangerous+'tunnel_code'" :rules="createForm.is_hazardous ? 'required' : ''"
                                                v-slot="{ errors }">
                              <small class="label">Tunnel Code</small>
                              <vs-input v-model="dangerous.tunnel_code" name="tunnel_code" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'packing_group'" :name="index_dangerous+'packing_group'"
                                                :rules="createForm.is_hazardous ? 'required' : ''" v-slot="{ errors }">
                              <small class="label">Packing Group</small>
                              <vs-input v-model="dangerous.packing_group" name="packing_group" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>
                         <div class="vx-row mb-3">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'flash_point'"
                                                :name="index_dangerous+'flash_point'" :rules="createForm.is_hazardous ? 'required' : ''"
                                                v-slot="{ errors }">
                              <small class="label">Flash Point</small>
                              <vs-input v-model="dangerous.flash_point" name="flash_point" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'emergency_contact'" :name="index_dangerous+'emergency_contact'"
                                                :rules="createForm.is_hazardous ? 'required' : ''" v-slot="{ errors }">
                              <small class="label">Emergency Contact</small>
                              <vs-input v-model="dangerous.emergency_contact" name="emergency_contact" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>

                         <div class="vx-row mb-3">
                          <div class="vx-col md:w-full w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'description'" :name="index_dangerous+'description'"
                                                rules="" v-slot="{ errors }">
                              <small class="label">Proper Shipping name</small>
                              <vs-input v-model="dangerous.description" name="description" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>

                       </vx-card-custom>
                      </vs-col>
              </vs-row>
            </span>
            <DhlProductCheck 
              v-if="separate_item_count > 0 && dhl_shipment" 
              :dhl_form="dhlForm" 
              :shipment_form="createForm" 
              :package_details="package_details"
              @update-product-code="onUpdateDhlProduct($event)"
              @update-error="error = $event"/>
            </div>
          </div>
        </ValidationObserver>

      </tab-content>
    </form-wizard>
      <vs-popup title="Confirm SLQ" :active.sync="shipByLimitedQtyPopup">
        <p>To ship by limited quantity you must adhere to packaging and labelling requirements.</p> <br>
        <p class="font-bold">Confirm that you have complied with these</p>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button @click="confirmShipByLimitedQty()" button="submit" color="danger" class="ml-auto mt-2">Confirm</vs-button>
          <vs-button @click="notConfirmShipByLimitedQty()" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
        </div>
      </vs-popup>
  </vs-popup>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {RepositoryFactory} from "@/repository/RepositoryFactory";

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import {defaultPagination, perPageList} from "@/constants/config";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

const CustomerRepository = RepositoryFactory.get('customer')
const CourierRepository = RepositoryFactory.get('courier')
const IncotermRepository = RepositoryFactory.get('incoterm');
const RegionsRepository = RepositoryFactory.get('regions');
const SageSettingsRepository = RepositoryFactory.get('sage_settings');
const DropDownRepository = RepositoryFactory.get('drop_down')
const DHLRepository = RepositoryFactory.get('dhl')

import DhlShipmentForm from '@/components/popups/courier/courier-shipment/components/DhlShipmentForm.vue'
import DhlProductCheck from '@/components/popups/courier/courier-shipment/components/DhlProductCheck.vue'

function initialState() {
  return {
    open: false,
    shipByLimitedQtyPopup: false,
    orders: [],
    filters: {},
    selected_items: [],
    selected_orders: [],
    pallet_details: [],
    createForm: {
      type: '',
      transport_mode: null,
      sub_transport_type: null,
      date_of_booking: moment().format('DD/MM/YYYY'),
      estimated_delivery_date: null,
      product_order_invoice_id: [],
      delivery_address: {
        address_line_1: '',
        address_line_2: '',
        address_line_3: '',
        town_state: '',
        postcode: '',
        country: '',
        delivery_instruction: ''
      },
      net_weight: 0,
      gross_weight: 0,
      is_hazardous: false,
      dangerous_goods_details: {
        un_number: '',
        legal_name: '',
        hazard_class_number: '',
        tunnel_code: '',
        packing_group: '',
        flash_point: '',
        description: '',
        emergency_contact: '',
        net_weight: '',
        gross_weight: '',
        cubic_meter: '',
      },
      dangerous_goods_details_arr: [],
    },
    is_included_dgn_note_items: false,
    separate_item_count: null,
    package_details: [],
    courier_suppliers: [],
    customers: [],
    company: {
      addresses: []
    },
    customer_addresses: [],
    selectedAddress: {
      post_code: ''
    },
    supplier_id: null,
    page : 1,
    total: 0,
    meta : {},
    sort : '',
    descriptionItems: perPageList,
    perPage: defaultPagination,
    types: ['Pallet', 'Small Pack'],
    transport_modes: [
      { label: 'Air', value: 'air' },
      { label: 'Road', value: 'road' }
    ],
    sub_transport_types: [
      { label: 'Cargo', value: 'cargo' },
      { label: 'Passenger', value: 'passenger' }
    ],
    incoterms: [],
    incoterm: '',
    sage_departments:[],
    regions:[],
    dhl_shipment: false,
    dhlForm: {},
    error: ''
  }
}

export default {
  name: "CreateOrderShipmentPopUp",
  data() {
    return initialState()
  },
  mixins : [Filter, SuccessMessage, ErrorMessages],
  methods: {
    ...mapActions(["fetchCountries"]),
    async openPopup() {
      try {
        Object.assign(this.$data, initialState())
        this.open = true;
        this.selected_items = []
        this.orders = []
        this.supplier_id = this.$route.params.id ? this.$route.params.id : null
        if(!this.supplier_id) {
          await this.fetchApprovedCourierShipments()
        } else {
          this.createForm.supplier_id = this.supplier_id
        }
        await this.getIncotermsList()
        await this.getSageDepartments()
        await this.getRegions()
        await this.fetchCountries()
        await this.onChangeSeparateItemCount()
        // await this.getProductOrderList()
        this.$forceUpdate();
      } catch (error) {

      }
    },
    async getIncotermsList() {
      await this.$vs.loading({
        container: '#product-orders-table',
        scale: 0.45
      })
      try {
        const {data} = await IncotermRepository.getListOfIncoterms(1, '', 20, '')
        this.incoterms =  data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#product-orders-table > .con-vs-loading')
    },
    async getSageDepartments(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
      this.sage_departments =  data.data
      this.$vs.loading.close()
    },
    async getRegions(){
      this.$vs.loading()
      const {data} = await RegionsRepository.getListOfRegions()
      this.regions =  data.data
      this.$vs.loading.close()
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      const {data} = await DropDownRepository.getCustomersList(`filter[search]=${search}&filter[status]=Approved`)
      vm.customers = data.data
      vm.selectedAddress = null
      loading(false);
    }, 350),
    checkItemSelected(order_id) {
      const items = this.selected_items.filter((n) =>  n.customer_order_id === order_id )
      return items.length > 0
    },
    async getProductOrderList() {
      await this.$vs.loading({
        container: '#product-orders-table',
        scale: 0.45
      })
      try {
        let data = []
        this.selected_orders = []
        this.selected_items = []
        data = (await CustomerRepository.getAllProductOrdersReadyToDispatch(this.page, `filter[search]=${this.company.company_name}&filter[post_code]=${this.selectedAddress ? this.selectedAddress.post_code : ''}&filter[line1]=${this.selectedAddress ? this.selectedAddress.line1 : ''}&filter[incoterm]=${this.incoterm ? this.incoterm : ''}`, this.perPage, this.sort)).data
        let orders = data.data.map((n) =>  {
          n.formulation_items.map((m) => {
            m.post_code = n.post_code

            const qty = Number(m.quantity).toFixed(2)
            const already_shipped_qty = m.courier_shipments.reduce((a, b) => a + Number(b.quantity), 0)
            m.remaining_dispatch = qty - Number(already_shipped_qty).toFixed(2)
            const defaultSalesOrder = (n.id || n.product_order_code) ? [{ id: n.id, order_code: n.product_order_code }] : []

            let stock_wos = m.inventory_stock.map((q) => {
              const foundWo = m.work_orders.find(wo => wo.id === q.work_order_id) || {}
              const woSalesOrders = (foundWo.sales_orders && foundWo.sales_orders.length)
                ? foundWo.sales_orders
                : ((q.sales_orders && q.sales_orders.length)
                  ? q.sales_orders
                  : defaultSalesOrder)
              return {
                completed_quantity: q.completed_quantity,
                courier_shipments: q.work_order_courier_shipments,
                courier_shipment: q.courier_shipment && q.courier_shipment.status.name !== 'Cancelled' ? q.courier_shipment : null,
                created_at: q.created_at,
                id: q.work_order_id,
                pack_size: q.completed_quantity,
                qc_status: q.work_order_qc_status,
                status: q.work_order_status,
                work_order_code: q.work_order_code,
                work_order_date: q.work_order_date,
                stock_id: q.id,
                stock_status: q.status,
                is_stock_item: true,
                sales_orders: woSalesOrders
              }
            })

            let not_completed_wos = m.work_orders.filter((x) => !['Pack Off Completed' , 'Mix Completed', 'Pack Off In Progress'].includes(x.status))
              .map((x) => {
                x.stock_status = 'N/A'
                x.stock_id = x.id
                x.courier_shipment = x.courier_shipments.filter((y) => y.status !== 'Cancelled')
                x.is_stock_item = false
                if (!x.sales_orders || !x.sales_orders.length) {
                  x.sales_orders = defaultSalesOrder
                }
                return x
              })
            // let arr = m.work_orders.concat(stock_wos)

            // m.work_orders = arr.reduce((acc, curr) => {
            //   const duplicate = acc.find(item => item.id === curr.id);
            //   if (!duplicate) {
            //     acc.push(curr);
            //   }
            //   return acc;
            // }, []);

            m.work_orders = stock_wos.concat(not_completed_wos);

            m.work_orders = m.work_orders.map(x => {
              const shipped_qty = x.is_stock_item ? (x.courier_shipment ? x.completed_quantity : 0) : x.courier_shipment.reduce((a, b) => a + Number(b.shipping_quantity), 0);
              x.shipped_quantity = shipped_qty;
              x.shipping_quantity = x.completed_quantity - shipped_qty;
              x.shipping_max_quantity = x.completed_quantity - shipped_qty;
              return x;
            });

            // m.work_orders = m.work_orders.filter((k) => {
            //   // if(k.courier_shipments.length !== 0 && k.courier_shipments[0].status !== 'Cancelled' ) {
            //   //   return false
            //   // }
            //   if(k.status === 'In Progress' && k.qc_status === '') {
            //     return true
            //   }
            //   if(k.status === 'Paused') {
            //     return true
            //   }
            //   return (k.status === 'Mix Completed' || k.status === 'Pack Off Completed' || k.status === 'In-Dispatch') && ['', 'Approved by QC', 'Submitted to QC'].includes(k.qc_status);
            // })

            m.available_to_dispatch = m.work_orders.reduce((acc, curr) => {
              return acc + Number(curr.shipping_max_quantity)
             }, 0)

            return m
          })
          return n
        })
        this.orders = orders.filter((n) => {
          n.formulation_items =  n.formulation_items.filter((m) => m.work_orders.length > 0 && Number(m.pending_dispatch_quantity) !== 0)
          return n.formulation_items.length > 0
        })
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#product-orders-table > .con-vs-loading')
    },
    async fetchCustomerDeliveryAddresses() {
      await this.$vs.loading({
        container: '#product-orders-table',
        scale: 0.45
      })
      const { data } = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.company.id)).data
      this.customer_addresses = data
      await this.getProductOrderList()
      this.$vs.loading.close('#product-orders-table > .con-vs-loading')
    },
    async fetchApprovedCourierShipments() {
      this.$vs.loading()
      const {data} = await DropDownRepository.getApprovedCourierList()
      this.courier_suppliers =  data.data
      this.$vs.loading.close()
    },
    async onChangeCourierType() {
      this.$vs.loading()
      const {data} = await DropDownRepository.getApprovedCourierList(`filter[service]=${this.createForm.type}`)
      this.courier_suppliers = data.data
      this.$vs.loading.close()
    },
    onChangeTransportMode() {
      if (this.createForm.transport_mode !== 'air') {
        this.createForm.sub_transport_type = null
      }
    },
    // filterQueryUpdate (){
    //   this.getProductOrderList()
    // },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.getProductOrderList()
      }

    },

    handleChangePage(page) {
      this.page=page;
      this.getProductOrderList()
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    onClickAddItem(tr_item, order, work_order = null) {
      // const qty = Number(item.quantity).toFixed(2)
      // const already_shipped_qty = item.courier_shipments.reduce((a, b) => a + Number(b.quantity), 0)
      // item.quantity = qty - Number(already_shipped_qty).toFixed(2)
      let item = {}
      Object.assign(item, tr_item)
      if(work_order) {
        item.work_orders = []
        item.work_orders.push(work_order)
      }
      item.selected_qty = item.pending_dispatch_quantity
      const check_exists = this.selected_items.find((n) => n.id === item.id)

      const selected_order_ids = this.selected_orders.map(o => o.id)
      const is_diff_order =
        selected_order_ids.length > 0 &&
        !selected_order_ids.includes(order.id)

       
        if (
          is_diff_order &&
          !this.$can('create-multiple-sales-orders-goods-out-logistics')
        ) {
          this.showErrorMessage(
            'You do not have permission to add multiple SO items to this shipment.',
            5000
          )
          return
        }
        
      if(check_exists) {
        this.selected_items = this.selected_items.map((n) => {
          if(n.id === item.id) {
            n.work_orders.push(work_order)
          }
          return n
        })
      } else if(this.selected_items.length === 0) {
        this.selected_items.push(item)
        const order_exists = this.selected_orders.includes(order)
        if(!order_exists) {
          this.selected_orders.push(order)
        }
      } else if(this.selected_items[0].post_code.toLowerCase() === item.post_code.toLowerCase() && this.selected_items[0].incoterm === item.incoterm) {
        this.selected_items.push(item)
        const order_exists = this.selected_orders.includes(order)
        if(!order_exists) {
          this.selected_orders.push(order)
        }
      } else {
        if (this.selected_items[0].post_code.toLowerCase() !== item.post_code.toLowerCase()) {
          this.showErrorMessage('Please select the same address items to shipping order', 5000)
        }
        if(this.selected_items[0].incoterm !== item.incoterm) {
          this.showErrorMessage('Please select the same incoterm items to shipping order', 5000)
        }
      }
    },
    onClickRemoveItem(id, order_id, stock_id = null) {
      if(stock_id) {
        let find = this.selected_items.find((n) => n.id === id)
        if(find.work_orders.length === 1) {
          this.selected_items = this.selected_items.filter((n) => n.id !== id)
          this.selected_orders = this.selected_orders.filter((n) => n.id !== order_id)
        } else {
          this.selected_items = this.selected_items.map((n) => {
            n.work_orders = n.work_orders.filter((m) => m.stock_id !== stock_id)
            return n
          })
        }
      } else {
        this.selected_items = this.selected_items.filter((n) => n.id !== id)
        this.selected_orders = this.selected_orders.filter((n) => n.id !== order_id)
      }
    },
    checkItemExists(id) {
      const find = this.selected_items.find((n) => n.id === id)
      return !!find
    },
    onClickAddOrder(order) {
      this.selected_orders.push(order)
    },
    onClickRemoveOrder(id) {
      this.selected_orders = this.selected_orders.filter((n) => n.id !== id)
    },
    checkOrderExists(id) {
      const find = this.selected_orders.find((n) => n.id === id)
      return !!find
    },
    checkItemWoSelected(wo_id, item_id, stock_id) {
      const related_item = this.selected_items.find((n) => n.id === item_id)
      if(related_item) {
        const related_wo = related_item.work_orders.filter((n) => n.stock_id === stock_id)
        return related_wo.length > 0
      } else {
        return false
      }
    },
    async onChangeSeparateItemCount() {
      this.package_details = []
      for (let step = 0; step < Number(this.separate_item_count); step++) {
        await this.onAddSeparateItemToArray()
      }
    },
    async onAddSeparateItemToArray() {
      const obj = {
        customer_order_id: this.selected_orders.length === 1 ? this.selected_orders[0].id : null,
        order_code: this.selected_orders.length === 1 ? this.selected_orders[0].product_order_code : null,
        item_number: '',
        gross_weight: '',
        net_weight: '',
        cubic_meter_lenght: '',
        cubic_meter_width: '',
        cubic_meter_height: ''
      }
      this.package_details.push(obj)
    },
    onClickOrderNumber(order, index) {
      this.package_details[index].customer_order_id = order.id
      this.package_details[index].order_code = order.product_order_code
    },

    generateBookingReferenceNumber() {
      const codes = []
      if (this.selected_items && this.selected_items.length) {
        this.selected_items.forEach(item => {
          if (item.work_orders && item.work_orders.length) {
            item.work_orders.forEach(wo => {
              if (wo.sales_orders && wo.sales_orders.length) {
                wo.sales_orders.forEach(so => {
                  const code = typeof so === 'object' && so !== null ? (so.order_code || so.product_order_code || so.code) : so
                  if (code && !codes.includes(code)) {
                    codes.push(code)
                  }
                })
              }
            })
          }
        })
      }
      if (codes.length === 0 && this.selected_orders && this.selected_orders.length) {
        this.selected_orders.forEach(order => {
          const code = order.product_order_code || order.order_code
          if (code && !codes.includes(code)) {
            codes.push(code)
          }
        })
      }
      return codes.join(' / ')
    },

    validateStep1() {

      return new Promise((resolve, reject) => {
        const post_codes = this.selected_items.map((n) => n.post_code)
        const incoterms = this.selected_items.map((n) => n.incoterm)
        const is_same_postal_code = post_codes.every((val, i, arr) => val === arr[0])
        const is_same_incoterms = incoterms.every((val, i, arr) => val === arr[0])

        if(this.selected_items.length === 0) {
          this.showErrorMessage('There are no goods in dispatch (pending) for this selected customer or address')
          reject("correct all values");
        }

        if(is_same_postal_code && is_same_incoterms) {
          this.createForm.delivery_address.address_line_1 = this.selected_orders[0].line1
          this.createForm.delivery_address.address_line_2 = this.selected_orders[0].line2
          this.createForm.delivery_address.address_line_3 = this.selected_orders[0].line3
          this.createForm.delivery_address.town_state = this.selected_orders[0].town_state
          this.createForm.delivery_address.postcode = this.selected_orders[0].post_code
          this.createForm.delivery_address.country = this.selected_orders[0].country
          this.createForm.delivery_address.delivery_instruction = this.selected_orders[0].delivery_instruction


          this.handleGrossWeight()
          this.createForm.booking_reference_number = this.generateBookingReferenceNumber()

          let count = 0
          this.selected_items.forEach((x) => {
            if(x.is_dgn_required) {
              count++
            }
          })
          if(count > 0) {
            this.createForm.is_hazardous = true
            this.is_included_dgn_note_items = true
            this.onChangeDgnRequired()
          }

          this.selected_items = this.selected_items.map((n)=> {
            const wo_qty_total = n.work_orders.reduce((a, b) => a + Number(b.completed_quantity), 0)
            if(Number(n.pending_dispatch_quantity) > Number(wo_qty_total)) {
              n.selected_qty = Number(wo_qty_total).toFixed(2)
            } else {
              n.selected_qty = Number(n.pending_dispatch_quantity).toFixed(2)
            }
            n.work_orders = n.work_orders.map((p) => { p.pack_size = p.pack_size ? p.pack_size : p.shipping_quantity; return p; })
            return n
          })

          // check incoterm is EXW
          if(this.selected_items[0].incoterm === 'EXW') {
            this.createForm.cost_of_delivery = 0
            this.separate_item_count = 0
            this.courier_suppliers = [{ id: null, company_name: ' Customer EXW' }]
            this.createForm.supplier_id = null
            this.createForm.type = 'Pallet'
          }

          if (!this.createForm.product_order_invoice_id || this.createForm.product_order_invoice_id.length === 0) {
            this.createForm.product_order_invoice_id = this.availableInvoices.map(inv => inv.id)
          } else {
            const validIds = new Set(this.availableInvoices.map(inv => inv.id))
            this.createForm.product_order_invoice_id = this.createForm.product_order_invoice_id.filter(id => validIds.has(id))
          }

          resolve(true)
        } else {
              this.showErrorMessage('Please select the same address items and same incoterms item to shipping order')
              reject("correct all values");
        }
      })
    },
    async validateStep2() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.showErrorMessage('please fill out the form correctly!')
      } else if(this.dhl_shipment && (this.error || !this.dhlForm.productCode)) {
        this.showErrorMessage('Please review DHL warnings or check DHL product availability and select a product!')
      } else {
        return new Promise((resolve, reject) => {
          if(this.selected_items[0].incoterm !== 'EXW') {
            this.createForm.net_weight = this.package_details.reduce((a, b) => a + Number(b.net_weight), 0)
          }
          // const total_selected_qty = this.selected_items.reduce((a,b) => a + Number(b.selected_qty), 0)
          const total_selected_qty = this.selected_items.reduce((acc, item) => acc + (item.work_orders || []).map(wo => wo.shipping_quantity).reduce((a, b) => a + Number(b), 0), 0);
          const epsilon = 0.001
          if (Math.abs(total_selected_qty - this.createForm.net_weight) > epsilon) {
            this.showErrorMessage('You have selected a net weight below your selected product qty');
            reject("Correct all values");
          } else {
            resolve(true);
          }

        })
      }
    },
    handleGrossWeight() {
      this.selected_orders = this.selected_orders.map((n) => {
        const related_items = this.selected_items.filter((m) => n.id === m.customer_order_id)
        n.gross_weight = related_items.reduce((a, b) => a + Number(b.selected_qty), 0)
        n.net_weight = related_items.reduce((a, b) => a + Number(b.selected_qty), 0)
        n.cubic_meter = null
        return n
      })
    },
    handleCustomerOrders() {
      try {
        const product_items = []
        const arr = this.selected_orders.forEach((n) => {
          n.formulation_items.forEach((m) => {
            product_items.push(m)
          })
        })
        this.selected_items = product_items.map((n) => {
          const qty = Number(n.quantity).toFixed(2)
          const already_shipped_qty = n.courier_shipments.reduce((a, b) => a + Number(b.quantity), 0)
          n.quantity = qty - Number(already_shipped_qty).toFixed(2)
          n.selected_qty = n.quantity
          return n
        }).filter((x) => Number(x.quantity) > 0 && ['In-Manufacturing', 'In-Dispatch'].includes(x.item_status))

        // const selected_id_arr = this.selected_items.map((n) => n.id)
        //
        // this.pallet_details = this.selected_orders.filter((n) => {
        //   const find = n.formulation_items.find((n) => selected_id_arr.includes(n.id))
        //   if(find) {
        //     return n
        //   }
        // })

      } catch (e) {
      }
    },
    async formSubmitted() {
      const vue = this;
      this.$vs.loading()
      try {
        const payload = {}
        Object.assign(payload, this.createForm)
        payload.gross_weight = Number(payload.gross_weight).toFixed(3)
        payload.net_weight = Number(payload.net_weight).toFixed(3)
        payload.cost_of_delivery = Number(payload.cost_of_delivery).toFixed(2)

        this.selected_items = this.selected_items.map((x) => {
          x.work_orders = x.work_orders.map((y) => {
            y.product_order_item_id = x.id
            return y
          })
          return x
        })

        payload.product_items = this.selected_items.map((n) => {
          return {
            item_id: n.id, 
            quantity: n.work_orders.reduce((a, b) => a + Number(b.shipping_quantity), 0).toString(), 
            price: Number(n.price).toFixed(2)
          }
        })

        //MAP WORK ORDERS
        let wo_arr = []
        this.selected_items.forEach((x) => {
          wo_arr = [...wo_arr, ...x.work_orders]
        })

        payload.work_orders = wo_arr.map((n) => {
          return {
            work_order_id: n.id, 
            quantity: Number(n.shipping_quantity).toFixed(4), 
            pack_size: Number(n.pack_size).toFixed(2), 
            product_order_item_id: n.product_order_item_id
          }
        })
        //END OF MAP WORK ORDERS

        if (this.package_details.length > 0) {
          payload.package_details = this.package_details.map((n) => {
            return {
              // customer_order_id: n.customer_order_id,
              item_number: n.item_number,
              gross_weight: Number(n.gross_weight).toFixed(3),
              net_weight : Number(n.net_weight).toFixed(3),
              cubic_meter_lenght : Number(n.cubic_meter_lenght).toFixed(3),
              cubic_meter_width : Number(n.cubic_meter_width).toFixed(3),
              cubic_meter_height : Number(n.cubic_meter_height).toFixed(3),
            }
          })
        } else {
          payload.package_details = []
        }

        if (payload.is_hazardous) {
          payload.is_shipped_by_limited_quantity = false
          payload.dangerous_goods_details = payload.dangerous_goods_details_arr
          delete payload.dangerous_goods_details_arr
        } else {
          payload.is_shipped_by_limited_quantity = true
          payload.dangerous_goods_details = []
        }

        if (payload.transport_mode !== 'air') {
          payload.sub_transport_type = null
        }
        payload.product_order_invoice_id = this.createForm.product_order_invoice_id || []
        const created_shipment = (await CourierRepository.createProductItemCourierShipment(payload)).data.data
        if(this.dhl_shipment) {
          await this.createDhlShipment(created_shipment)
        } else {
          this.selected_items = []
          this.showSuccessMessage('Courier shipment created')
          location.reload()
          this.open = false;
        }
      }catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    onChangeDgnRequired() {
      if (this.createForm.is_hazardous) {
        this.selected_items.forEach((x) => {
          const obj = {
            product_code: x.formulation_code,
            un_number:  x.dangerous_goods_note ? x.dangerous_goods_note.un_number : '',
            legal_name: x.formulation_legal_name ? x.formulation_legal_name : '',
            hazard_class_number: x.dangerous_goods_note ? x.dangerous_goods_note.hazard_class_number : '',
            tunnel_code: '',
            packing_group: '',
            flash_point: x.dangerous_goods_note ? x.dangerous_goods_note.flash_point : '' ,
            description: x.dangerous_goods_note ? x.dangerous_goods_note.description : '',
            emergency_contact: '',
          }
          const find = this.createForm.dangerous_goods_details_arr.find((n) => n.product_code === x.formulation_code)
          if(!find && x.is_dgn_required) {
            this.createForm.dangerous_goods_details_arr.push(obj)
          }
        })
      } else {
        this.shipByLimitedQtyPopup = true
      }
    },
    confirmShipByLimitedQty() {
      this.shipByLimitedQtyPopup = false
    },

    notConfirmShipByLimitedQty() {
      this.shipByLimitedQtyPopup = false
      this.createForm.is_hazardous = true
    },

    onDeleteDangerousItem(product_code) {
      this.createForm.dangerous_goods_details_arr = this.createForm.dangerous_goods_details_arr.filter((n) => n.product_code !== product_code)
    },
    checkItemInDangerList(product_code) {
      const find = this.createForm.dangerous_goods_details_arr.find((x) => x.product_code === product_code)
      return !find
    },
    addItemToDangerList(item) {
      const obj = {
        product_code: item.formulation_code,
        un_number:  item.dangerous_goods_note ? item.dangerous_goods_note.un_number : '',
        legal_name: '',
        hazard_class_number: item.dangerous_goods_note ? item.dangerous_goods_note.hazard_class_number : '',
        tunnel_code: '',
        packing_group: '',
        flash_point: item.dangerous_goods_note ? item.dangerous_goods_note.flash_point : '' ,
        description: item.dangerous_goods_note ? item.dangerous_goods_note.description : '',
        emergency_contact: '',
        net_weight: item.quantity,
        gross_weight: item.selected_qty,
        cubic_meter: '',
      }
      this.createForm.dangerous_goods_details_arr.push(obj)
    },
    orderItemStatusNameFactory(status_name, work_orders = []) {
      if (!status_name) {
        return 'Submitted'
      }
      if (work_orders.length === 0) {
        return status_name
      }
      if (work_orders.length > 1) {
        return 'Multiple work orders'
      }
      if (work_orders.length === 1) {
        return work_orders[0].status
      }
    },
    orderItemQcStatusNameFactory(work_orders = []) {
      if (work_orders.length > 1) {
        return 'Multiple work orders'
      }
      if (work_orders.length === 1) {
        return work_orders[0].qc_status ? work_orders[0].qc_status :' Pre QC'
      }
    },
    manufacturingDateFactory(work_orders) {
      const find = work_orders.find((n) => n.status === 'Pack Off Completed')
      if(find) {
        return find.work_order_date
      } else {
        return 'N/A'
      }
    },
    onClickClose() {
      location.reload()
    },
    totalCalculator() {
      let items_arr = []
      this.orders.forEach((x) => {
        items_arr = [...items_arr, ...x.formulation_items]
      })
      items_arr = items_arr.filter((n) => n.work_orders.length > 0)
      return Number(items_arr.reduce((a, b) => a + Number(b.pending_dispatch_quantity), 0)).toFixed(2)
    },
    totalQtyAvailable(formulation_items) {
      let items = formulation_items.filter((n) => n.work_orders.length > 0 )
      return Number(items.reduce((a, b) => a + Number(b.available_to_dispatch), 0)).toFixed(2)
    },
    onClickViewShipment(shipment_id) {
      this.open = false
      this.$router.push({path: `/pages/courier-shipments?open=${shipment_id}`})
      location.reload()
    },
    shipmentCodeFilter(shipment) {
      return shipment instanceof Array ? shipment.map(x => x.shipment_code).toString() : shipment ? shipment.courier_shipment_code : 'N/A';
      // return shipments.filter((x) => !['Cancelled', 'Returned'].includes(x.status)).map((x) => x.shipment_code).toString()
    },
    ifShipmentCanMake(shipments, shipping_max_quantity) {
      // const shipment_qty = shipments.filter((x) => !['Cancelled', 'Returned'].includes(x.status)).reduce((a, b) => a + Number(b.shipping_quantity), 0)
      // return Number(completed_quantity) > Number(shipment_qty)
      return Number(shipping_max_quantity) > 0
    },
    calculateSelectedQty(work_orders) {
      return work_orders.reduce((a, b) => a + Number(b.shipping_quantity), 0)
    },
    async onInputDhlConfig() {
      if(!this.dhl_shipment) {
        return
      }
      this.createForm.type = 'Small Pack'
      await this.onChangeCourierType()
      const find = this.courier_suppliers.find(item => item.company_name === 'DHL INTERNATIONAL (UK) LTD')
      this.createForm.supplier_id = find ? find.id : null
    },
    pickCountryCode(country) {
      if(country === 'United Kingdom') {
        return 'GB'
      }
      const find = this.countries.find(co => co.name === country)
      return find ? find.iso_code : country
    },
    async createDhlShipment(created_shipment) {
      try {
        let payload = {}
        Object.assign(payload, this.dhlForm)

        payload.plannedShippingDateAndTime = moment(payload.plannedShippingDateAndTime).format("YYYY-MM-DD[T]HH:mm:ss[GMT]Z")
        payload.customerDetails.receiverDetails = {
          contactInformation : {
            companyName: created_shipment.customer_company_name,
            fullName: created_shipment.customer_company_name,
            phone: '0000000000'
          },
          postalAddress: {
            addressLine1: created_shipment.delivery_address.address_line_1,
            cityName: created_shipment.delivery_address.address_line_2,
            countryCode: this.pickCountryCode(created_shipment.delivery_address.country),
            postalCode: created_shipment.delivery_address.postcode,
          }
        }
        payload.customerDetails.shipperDetails.postalAddress.countryCode = this.pickCountryCode(payload.customerDetails.shipperDetails.postalAddress.countryCode)
        payload.content.packages = created_shipment.package_details.map((item) => {
          return {
            weight: Number(item.gross_weight),
            dimensions: {
              height: Number(item.cubic_meter_height),
              length: Number(item.cubic_meter_lenght),
              width: Number(item.cubic_meter_width)
            }
          }
        })
        payload.content.description = created_shipment.courier_shipment_code
        payload.content.incoterm = this.selected_items[0].incoterm
        payload.customerReferences = [
          {
            value: this.createForm.booking_reference_number || created_shipment.booking_reference_number || this.generateBookingReferenceNumber(),
            typeCode: "CU"
          }
        ]

        payload.content.isCustomsDeclarable = false
        // payload.content.isCustomsDeclarable = payload.customerDetails.shipperDetails.postalAddress.countryCode !== payload.customerDetails.receiverDetails.postalAddress.countryCode
        
        if(payload.content.isCustomsDeclarable) {
          payload.content.exportDeclaration = {
            lineItems: created_shipment.product_items.map((item, index) => {
              return {
                number: index + 1,
                description: item.formulation_code,
                price: Number(item.price),
                quantity: {
                  value: Number(item.shipping_quantity),
                  unitOfMeasurement: 'KG',
                },
                manufacturerCountry: payload.customerDetails.shipperDetails.postalAddress.countryCode,
                weight: {
                  netValue: Number(item.shipping_quantity),
                  grossValue: Number(item.shipping_quantity)
                }
              }
            }),
            invoice: {
              number : payload.content.exportDeclaration.invoice.number,
              date: payload.content.exportDeclaration.invoice.date
            }
          }
        } else {
          const { exportDeclaration, ...rest } = payload.content
          payload.content = rest
        }
        if (payload.valueAddedServices && payload.valueAddedServices.length > 0) {
          payload.valueAddedServices = payload.valueAddedServices.map(s => typeof s === 'string' ? { serviceCode: s } : s)
        } else {
          delete payload.valueAddedServices
        }
        payload.courier_shipment_id = created_shipment.id
        payload.product_order_invoice_id = this.createForm.product_order_invoice_id || []
        await DHLRepository.createShipment(payload)
        this.selected_items = []
        this.showSuccessMessage('Courier shipment created')
        location.reload()
        this.open = false;
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    onUpdateDhlProduct(product) {
      this.dhlForm.productCode = product.productCode
      this.createForm.estimated_delivery_date  = moment(product.estimatedDeliveryDateAndTime).format('DD/MM/YYYY')
      this.createForm.cost_of_delivery = Number(product.totalPrice).toFixed(2)
    },
    onClickSelectAllInvoices() {
      this.createForm.product_order_invoice_id = this.availableInvoices.map(inv => inv.id)
    },
    onClickRemoveAllInvoices() {
      this.createForm.product_order_invoice_id = []
    }
  },
  watch : {
    page(){
      this.getProductOrderList()
    },
    perPage() {
      this.getProductOrderList()
    },
    package_details: {
      deep: true,
      handler() {
        this.createForm.gross_weight = this.package_details.reduce((a, b) => a + Number(b.gross_weight), 0)
        this.createForm.net_weight = this.package_details.reduce((a, b) => a + Number(b.net_weight), 0)
        const total_selected_qty = this.selected_items.reduce((a,b) => a + Number(b.selected_qty), 0)
        if(Number(total_selected_qty) < Number(this.createForm.net_weight)) {
          this.showErrorMessage('You have entered a net weight that exceeds the net weight of the shipment')
        }
      }
    },
  },
  computed: {
    ...mapGetters(["countries"]),
    availableInvoices() {
      const invoices = []
      const seenIds = new Set()
      if (this.selected_orders && this.selected_orders.length) {
        this.selected_orders.forEach(order => {
          if (order.product_order_invoices && Array.isArray(order.product_order_invoices)) {
            order.product_order_invoices.forEach(inv => {
              if (inv && inv.id && !seenIds.has(inv.id)) {
                seenIds.add(inv.id)
                invoices.push(inv)
              }
            })
          }
        })
      }
      return invoices
    }
  },
  components: {
    FormWizard,
    TabContent,
    'v-select': vSelect,
    flatPickr,
    DhlShipmentForm,
    DhlProductCheck
  }
}
</script>

<style scoped>
.create-courier-shipment-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}

</style>
